import {
    UPDATE_CONFIG,
} from '../../actionTypes';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_CONFIG:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/services/config/reducer.js